var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionButton',{staticClass:"mt-4",attrs:{"actionIcon":"$sl-bankid"},on:{"click":function($event){return _vm.doExternalLogin()}}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }